<template>
  <div>
    <template v-if="filteredFaq.length > 0">
      <vs-collapse accordion class="p-0" type="margin">
        <vs-collapse-item :class="{'mt-0': !index}"
                          :key="courseFaq.id"
                          :ref="`collapseItem${courseFaq.id}`"
                          @click.native="onCollapseClick(courseFaq)"
                          class="faq-bg rounded-lg"
                          v-for="(courseFaq, index) in filteredFaq">
          <div slot="header">
            <h5 v-html="courseFaq.question"></h5>
          </div>
          <div v-html="courseFaq.answer"></div>
        </vs-collapse-item>
      </vs-collapse>
    </template>
    <template v-else>
      <div class="text-center pt-4">
        <h3>{{ $t('faq.no-faq-found') }}</h3>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: "FaqCollapse",
    props: [
      'filteredFaq',
    ],
    data() {
      return {
        isOpen: false,
      }
    },
    methods:{
      async onCollapseClick(courseFaq){
        if(this.$refs[`collapseItem${courseFaq.id}`][0].$el.className.indexOf('open-item') > -1){
          this.$emit('updateHitRateCount', courseFaq)
        }
      }
    }
  }
</script>

<style scoped>

</style>
